import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  browserGpsInfo,
  checkScanDistanceGreater,
  getEventUpdateDetails,
  getPromptFileIdsForUrls,
  isLargeScreen,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { PagesService } from '../../../pages/pages/pages.service';
import { userUpdateTable } from '../../../pages/pages/tableDetails';
import { DataCheckService } from '../../services/data-check.service';
import { DeviceInfoService } from '../../services/device-info.service';
import { MediaPreviewComponent } from '../media-preview/media-preview.component';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { ViewUserDetailComponent } from '../view-user-detail/view-user-detail.component';
import { WebSocketService } from '../../services/web-socket.service';

@Component({
  selector: 'gtapp-selected-event-detail',
  templateUrl: './selected-event-detail.component.html',
  styleUrl: './selected-event-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectedEventDetailComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() selectedEvent: any;
  @Input() selectedEventFrom: string = 'job';
  @Input() extraCheck: boolean = false;
  @Input() userEventDetailsTableView: any;

  @Output() editUserComment = new EventEmitter();
  @Output() deleteRestoreUserUpdate = new EventEmitter();
  @Output() goBack = new EventEmitter();

  browserGpsInfo: any = browserGpsInfo;
  canEditEventUpdate: boolean = false;
  canDeleteRestoreCommentPhoto: boolean = false;
  lastCommentEditTime: any;

  subscriberUserId: any;
  isAdmin: boolean = false;
  isDispatchUser: boolean = false;
  scanDistanceInfo: any = {};

  isLargeScreen = isLargeScreen;

  restoredDetails: any;
  deletedDetails: any;
  editedDetails: any;

  deviceInfoSubscription: any;

  promptFileIds: any = [];

  promptFileDataUrls: any = {};

  userDetailPopoverTemplate = ViewUserDetailComponent;
  webSocketSubscription: any;
  constructor(
    private dataCheckService: DataCheckService,
    private appService: AppService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private deviceInfoService: DeviceInfoService,
    private pageService: PagesService,
    private cdr: ChangeDetectorRef,
    private webSocketService: WebSocketService,
  ) {
    this.deviceInfoSubscription =
      this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
        if ('goBack' in value) {
          this.hideDetails();
        }
      });
  }
  ngOnDestroy(): void {
    if (this.webSocketSubscription) this.webSocketSubscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        if (
          ['wsn_video_upload_check_response'].includes(event?.event) &&
          this.selectedEvent?.file_id == event?.file_id &&
          this.selectedEvent?.file
        ) {
          this.selectedEvent.file_additional_info = {
            ...this.selectedEvent?.file_additional_info,
            uploading: false,
          };
          this.cdr.detectChanges();
        }
      });

    this.pageService.miscSubjectParam.next({
      updateEvent: 'showDetail',
    });
    this.isAdmin = this.dataCheckService.isUserAdmin();
    this.isDispatchUser = this.dataCheckService.isDispatchUser();
    let userData = this.appService.getUserData();

    this.subscriberUserId = userData?.subscriber?.subscriber_user_id;

    if (!this.userEventDetailsTableView) {
      this.userEventDetailsTableView = userUpdateTable.desktopTable;
    }
    this.fetchResults();
    this.appService.initializeBootstrapTooltips();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isLargeScreen)
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);

    this.fetchResults();
  }

  fetchResults() {
    const newPromptFileIds = getPromptFileIdsForUrls(
      this.selectedEvent?.prompts || [],
      this.promptFileIds || [],
    );

    if (newPromptFileIds && newPromptFileIds?.length) {
      this.promptFileIds = newPromptFileIds;

      this.getS3Urls();
    }

    this.scanDistanceInfo = {};
    this.canEditEventUpdate = this.canEditEventUpdateCheck();
    // this.getDetails();
    // this.restoredDetails = this.getRestoreDetails();
    // this.deletedDetails = this.getDeleteDetails();
    // this.editedDetails = this.getEditedDetails();
    const details = getEventUpdateDetails(
      this.selectedEvent,
      this.selectedEventFrom,
    );

    this.restoredDetails = details?.restore;
    this.deletedDetails = details?.delete;
    this.editedDetails =
      details?.editedPatrol || details?.editedJob || details?.editedIncident;

    this.canDeleteRestoreCommentPhoto = this.canDeleteRestorUpdate();

    if (
      this.selectedEvent?.history_changes?.length &&
      (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
        this.isAdmin ||
        this.isDispatchUser)
    ) {
      let sortedComments = this.selectedEvent?.history_changes?.sort(
        (a: any, b: any) =>
          new Date(a?.updated_at).getTime() - new Date(b?.updated_at).getTime(),
      );
      this.lastCommentEditTime = sortedComments[sortedComments?.length - 1];
    }

    if (
      this.selectedEvent &&
      this.selectedEvent?.checkpoint_details &&
      this.selectedEvent?.checkpoint_details?.id
    ) {
      if ([0, 6, 12].includes(this.selectedEvent?.event_action)) {
        this.selectedEvent.gps.gpsToolTip = 'Scan Location';
      }
      this.scanDistanceInfo = checkScanDistanceGreater(this.selectedEvent);

      if (this.scanDistanceInfo?.scanDistance)
        this.selectedEvent.checkpoint_details.scanDistanceInfo =
          this.scanDistanceInfo;
    }
    if (
      this.selectedEvent?.file_additional_info?.uploading &&
      this.selectedEvent?.file_id &&
      this.selectedEvent?.file
    ) {
      this.webSocketService.sendData({
        event: 'wsn_video_upload_check',
        file_id: this.selectedEvent?.file_id,
      });
    }
  }

  hideDetails() {
    this.goBack.emit();
  }
  canDeleteRestorUpdate() {
    switch (this.selectedEventFrom) {
      case 'job':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin ||
            this.isDispatchUser) &&
          [7, 8, 19].includes(this.selectedEvent?.event_action) &&
          this.extraCheck
        );

      case 'user_update_history':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin) &&
          this.selectedEvent?.event_type === 'Patrol Update' &&
          [1, 2, 7].includes(this.selectedEvent?.event_action) &&
          new Date().getTime() -
            new Date(this.selectedEvent?.updated_at).getTime() <
            3600 * 1000 &&
          this.extraCheck
        );
      case 'patrol':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin) &&
          this.selectedEvent?.company_id &&
          [1, 2, 7].includes(this.selectedEvent?.event_action) &&
          // new Date().getTime() -
          //   new Date(this.selectedEvent?.updated_at).getTime() <
          //   72 * 3600 * 1000 &&
          this.extraCheck
        );
    }
    return false;
  }

  canEditEventUpdateCheck() {
    switch (this.selectedEventFrom) {
      case 'job':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin ||
            this.isDispatchUser) &&
          [7, 8, 19].includes(this.selectedEvent?.event_action) &&
          this.extraCheck
        );
      case 'patrol':
        return (
          this.subscriberUserId == this.selectedEvent?.subs_user_id &&
          this.selectedEvent?.company_id &&
          [1, 2, 7].includes(this.selectedEvent?.event_action) &&
          new Date().getTime() -
            new Date(this.selectedEvent?.updated_at).getTime() <
            72 * 3600 * 1000 &&
          this.extraCheck
        );
      case 'user_update_history':
        return (
          this.subscriberUserId == this.selectedEvent?.subs_user_id &&
          this.selectedEvent?.company_id &&
          this.selectedEvent?.event_type === 'Patrol Update' &&
          [1, 2, 7].includes(this.selectedEvent?.event_action) &&
          new Date().getTime() -
            new Date(this.selectedEvent?.updated_at).getTime() <
            72 * 3600 * 1000 &&
          this.extraCheck
        );
    }
    return false;
  }

  getLastCommentEditedDateTime(history: any) {
    let sortedComments = history?.sort(
      (a: any, b: any) =>
        new Date(a?.updated_at).getTime() - new Date(b?.updated_at).getTime(),
    );
    return sortedComments[sortedComments?.length - 1];
  }
  onOpenFile(file: any) {
    this.dialogService.open(MediaPreviewComponent, {
      data: {
        mediaSrc: file?.file || file?.file_url,
        timeStamp: file.updated_at,
        mediaExtension: file?.file_extension,
      },
    });
  }
  routeToEventPage() {
    if (this.selectedEvent?.event_type?.toLowerCase() === 'job update') {
      this.router.navigate([`/job-detail/JOBID`], {
        queryParams: { jId: this.selectedEvent?.event_id },
      });
    } else if (
      this.selectedEvent?.event_type?.toLowerCase() ===
      'scheduled patrol update'
    ) {
      this.router.navigate([
        '/view-runsheet',
        {
          rKey: String(this.selectedEvent?.event_id),
        },
      ]);
    } else {
      this.router.navigate([
        '/view-incident',
        { inKey: this.selectedEvent?.event_id },
      ]);
    }
  }
  onCheckpointRedirect(cpId: any) {
    this.router.navigate(['/view-checkpoints', { cpKey: String(cpId) }]);
  }
  getS3Urls() {
    this.pageService
      .manageS3Urls({ file_ids: this.promptFileIds }, { get_file_urls: 1 })
      .subscribe((response: any) => {
        this.promptFileDataUrls = response?.data || {};
        this.cdr.detectChanges();
      });
  }
}
